/* terranova · tema Shopify · interacciones globales
   - Nav (scroll, menú móvil), revelados, títulos por palabras, contadores.
   - Compatible con el editor de temas: cada sección se reinicia con
     shopify:section:load (ver TN.init). Otros scripts se registran con TN.onInit(fn).
*/
(function () {
  'use strict';
  var TN = (window.TN = window.TN || {});
  var root = document.documentElement;
  TN.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  TN.design = !!(window.Shopify && window.Shopify.designMode);
  TN.reveals = !root.classList.contains('no-reveals') && !TN.reduced;
  TN.clamp01 = function (v) { return Math.min(1, Math.max(0, v)); };
  TN.lerp = function (a, b, t) { return a + (b - a) * t; };
  TN.easeIO = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  var hooks = [];
  var unloadHooks = [];
  var booted = false;
  /* Registra una función de inicio: se ejecuta en el arranque (DOMContentLoaded) y en cada
     shopify:section:load. Si el arranque ya ocurrió, se ejecuta de inmediato sobre el documento. */
  TN.onInit = function (fn) {
    hooks.push(fn);
    if (booted) { try { fn(document, false); } catch (err) { console.error('[terranova]', err); } }
  };
  TN.onUnload = function (fn) { unloadHooks.push(fn); };

  /* ---------------- nav ---------------- */
  var lastY = 0;
  function navState() {
    var nav = document.getElementById('nav');
    if (!nav) return;
    var y = window.scrollY;
    nav.classList.toggle('scrolled', y > 40);
    nav.classList.toggle('hide', y > window.innerHeight * 1.2 && y > lastY + 4 && !document.body.classList.contains('menu-open'));
    lastY = y;
  }
  TN.navState = navState;
  window.addEventListener('scroll', function () { if (!TN.homeScroll) navState(); }, { passive: true });

  function setMenu(open) {
    var menu = document.querySelector('.mobile-menu');
    var burger = document.querySelector('.burger');
    var wasOpen = document.body.classList.contains('menu-open');
    document.body.classList.toggle('menu-open', open);
    if (menu) {
      menu.classList.toggle('open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      menu.inert = !open;
    }
    /* mientras el menú está abierto, el resto de la página no recibe foco */
    document.querySelectorAll('#MainContent, .shopify-section-group-footer-group, .tn-footer-section, .wa-chat, .wa-float').forEach(function (el) { el.inert = open; });
    if (burger) { burger.setAttribute('aria-expanded', open ? 'true' : 'false'); burger.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú'); }
    if (open && menu) {
      var first = menu.querySelector('a');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
    } else if (wasOpen && burger && menu && menu.contains(document.activeElement)) {
      burger.focus({ preventScroll: true });
    }
  }
  TN.closeMenu = function () { setMenu(false); };
  window.closeMenu = TN.closeMenu; /* compatibilidad */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.burger');
    if (b) { e.preventDefault(); setMenu(!document.body.classList.contains('menu-open')); return; }
    var a = e.target.closest && e.target.closest('.mobile-menu a');
    if (a) setMenu(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('menu-open')) setMenu(false);
  });

  /* ---------------- títulos por palabras (.srv) ---------------- */
  function splitWords(scope) {
    if (!TN.reveals) return;
    scope.querySelectorAll('.srv:not([data-split])').forEach(function (el) {
      var frag = [];
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3) {
          n.textContent.split(/\s+/).filter(Boolean).forEach(function (w) { frag.push({ t: w, el: null }); });
        } else if (n.nodeType === 1) {
          if (n.tagName === 'BR') { frag.push({ br: true }); return; }
          n.textContent.split(/\s+/).filter(Boolean).forEach(function (w) { frag.push({ t: w, el: n }); });
        }
      });
      for (var i = frag.length - 1; i > 0; i--) {
        if (!frag[i].br && !frag[i - 1].br && /^[^\wÀ-ÿ]+$/.test(frag[i].t)) { frag[i - 1].t += frag[i].t; frag.splice(i, 1); }
      }
      var k = 0;
      el.innerHTML = frag.map(function (w) {
        if (w.br) return '<br>';
        var inner = w.t.replace(/&/g, '&amp;').replace(/</g, '&lt;');
        if (w.el) { var c = w.el.cloneNode(false); c.textContent = w.t; inner = c.outerHTML; }
        return '<span class="w"><i style="transition-delay:' + (k++ * 45) + 'ms">' + inner + '</i></span>';
      }).join(' ');
      el.setAttribute('data-split', '');
    });
  }

  /* ---------------- revelados ---------------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;
  var ioIW = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); ioIW.unobserve(e.target); } });
  }, { threshold: 0, rootMargin: '0px 0px -10% 0px' }) : null;

  function observeReveals(scope) {
    var els = scope.querySelectorAll('.rv:not(.in),.srv:not(.in),.iw:not(.in)');
    if (!TN.reveals || !io) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    els.forEach(function (el) { (el.classList.contains('iw') ? ioIW : io).observe(el); });
  }
  var sweep = null;
  function startSweep() {
    if (sweep) return;
    sweep = setInterval(function () {
      var pending = document.querySelectorAll('.rv:not(.in),.srv:not(.in),.iw:not(.in)');
      if (!pending.length) { clearInterval(sweep); sweep = null; return; }
      pending.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 1.05 && r.bottom > -40) el.classList.add('in'); });
    }, 700);
  }

  /* ---------------- contadores ---------------- */
  var cIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, end = +el.dataset.count, t0 = performance.now(), dur = 1400;
      (function tick(t) { var k = TN.clamp01((t - t0) / dur), ez = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(end * ez); if (k < 1) requestAnimationFrame(tick); })(t0);
      cIO.unobserve(el);
    });
  }, { threshold: 0.6 }) : null;
  function counters(scope) {
    scope.querySelectorAll('[data-count]:not([data-counted])').forEach(function (c) {
      c.setAttribute('data-counted', '');
      if (TN.reduced || !cIO || TN.design) c.textContent = c.dataset.count; else cIO.observe(c);
    });
  }

  /* ---------------- init / editor ---------------- */
  TN.init = function (scope, isSectionLoad) {
    scope = scope || document;
    splitWords(scope);
    observeReveals(scope);
    counters(scope);
    hooks.forEach(function (fn) { try { fn(scope, !!isSectionLoad); } catch (err) { console.error('[terranova]', err); } });
    startSweep();
  };
  /* Los scripts con defer se ejecutan con readyState = 'interactive' y antes de DOMContentLoaded:
     esperar a ese evento garantiza que home.js y los demás ya registraron sus funciones. */
  function boot() { if (booted) return; booted = true; TN.init(document, false); navState(); }
  if (document.readyState === 'complete') boot();
  else { document.addEventListener('DOMContentLoaded', boot); window.addEventListener('load', boot); }

  document.addEventListener('shopify:section:load', function (e) { TN.init(e.target, true); });
  document.addEventListener('shopify:section:unload', function (e) {
    unloadHooks.forEach(function (fn) { try { fn(e.target); } catch (err) { console.error('[terranova]', err); } });
  });
  document.addEventListener('shopify:section:select', function (e) {
    e.target.querySelectorAll('.rv,.srv,.iw').forEach(function (el) { el.classList.add('in'); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    t.querySelectorAll && t.querySelectorAll('.rv,.srv,.iw').forEach(function (el) { el.classList.add('in'); });
    if (t.classList) t.classList.add('in');
    if (t.tagName === 'DETAILS') t.open = true;
  });
})();

/* terranova · catálogo: galería de producto y selectores de cantidad.
   Delegación de eventos en document (sobrevive a recargas de sección en el editor);
   TN.onInit sincroniza el estado inicial de cada ámbito. */
(function () {
  'use strict';

  /* ---------------- galería ---------------- */
  function showMedia(gal, id) {
    var main = gal.querySelector('.pg-main');
    if (!main) return;
    var found = false;
    main.querySelectorAll('.pg-slide').forEach(function (s) {
      var on = s.getAttribute('data-media-id') === String(id);
      if (on) found = true;
      s.hidden = !on;
    });
    if (!found) return;
    gal.querySelectorAll('.pg-thumb').forEach(function (t) {
      t.setAttribute('aria-pressed', t.getAttribute('data-media-target') === String(id) ? 'true' : 'false');
    });
  }

  /* ---------------- cantidad ---------------- */
  function stepQty(btn) {
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;
    var max = parseInt(input.getAttribute('max'), 10);
    var v = (parseInt(input.value, 10) || 0) + step;
    if (v < min) v = min;
    if (!isNaN(max) && v > max) v = max;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var thumb = e.target.closest('.pg-thumb');
    if (thumb) {
      var gal = thumb.closest('.prod-gal');
      if (gal) showMedia(gal, thumb.getAttribute('data-media-target'));
      return;
    }
    var q = e.target.closest('[data-qty-step]');
    if (q) { e.preventDefault(); stepQty(q); }
  });

  /* ---------------- estado inicial por ámbito ---------------- */
  function init(scope) {
    (scope || document).querySelectorAll('.prod-gal:not([data-tn-gal])').forEach(function (gal) {
      gal.setAttribute('data-tn-gal', '');
      var first = gal.querySelector('.pg-thumb');
      if (first) showMedia(gal, first.getAttribute('data-media-target'));
    });
  }

  window.TN.onInit(init);
})();

/* ---------------------------------------------------------------------------
   Chat de WhatsApp por asesor (snippets/wa-chat.liquid). Sin apps externas.
   Sin JavaScript el botón abre WhatsApp directo; con JavaScript abre la ventana.
--------------------------------------------------------------------------- */
(function () {
  'use strict';
  function setup(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var chats = [];
    if (scope.matches && scope.matches('[data-wa-chat]')) chats.push(scope);
    scope.querySelectorAll('[data-wa-chat]').forEach(function (c) { chats.push(c); });
    chats.forEach(function (chat) {
      if (chat.dataset.waReady) return;
      var toggle = chat.querySelector('[data-wa-toggle]');
      var panel = chat.querySelector('.wa-panel');
      if (!toggle || !panel) return;
      chat.dataset.waReady = '1';
      toggle.setAttribute('aria-haspopup', 'dialog');
      toggle.setAttribute('aria-expanded', 'false');
      var timer;
      function isOpen() { return toggle.getAttribute('aria-expanded') === 'true'; }
      function open() {
        clearTimeout(timer);
        panel.hidden = false;
        requestAnimationFrame(function () { panel.classList.add('open'); });
        toggle.setAttribute('aria-expanded', 'true');
        var first = panel.querySelector('.wa-cta, .wa-person, [data-wa-close]');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
      }
      function close(returnFocus) {
        if (!isOpen()) return;
        panel.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        timer = setTimeout(function () { panel.hidden = true; }, 230);
        if (returnFocus) toggle.focus({ preventScroll: true });
      }
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        if (isOpen()) close(false); else open();
      });
      panel.querySelectorAll('[data-wa-close]').forEach(function (b) {
        b.addEventListener('click', function () { close(true); });
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.stopPropagation(); close(true); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) close(true);
      });
      document.addEventListener('click', function (e) {
        if (isOpen() && !chat.contains(e.target)) close(false);
      });
    });
  }
  if (window.TN && window.TN.onInit) window.TN.onInit(function (root) { setup(root); });
  else document.addEventListener('DOMContentLoaded', function () { setup(document); });
})();
